import { EnvironmentProviders, makeEnvironmentProviders, StaticProvider } from '@angular/core';
import { DcEnvironmentCode, type DcTenantCode } from '@rma/generic/core/instance';
import { provideRmaEnvironmentStatic } from './environment.provider';
import { provideRmaLocaleStatic } from './locale.provider';
import { provideRmaTenantStatic } from './tenant.provider';

export function provideRmaInstance(tenantCode: DcTenantCode, envCode: DcEnvironmentCode): EnvironmentProviders {
  return makeEnvironmentProviders(provideRmaInstanceStatic(tenantCode, envCode));
}

export function provideRmaInstanceStatic(tenantCode: DcTenantCode, envCode: DcEnvironmentCode): StaticProvider[] {
  return [provideRmaTenantStatic(tenantCode), provideRmaEnvironmentStatic(envCode), provideRmaLocaleStatic(tenantCode)];
}
